module.exports = __webpack_public_path__ + "img/lg_ring_g_c_0_null@3x.c7baeecb.png";